import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "../../assests/images";
import PatientDetails from "../../components/dashboard/patient-details";

const CreateNewRequest: React.FC = () => {
  // state value
  const { state } = window.history;

  // Page level variables
  const navigate = useNavigate();

  // Handled events and functions
  const handleOnBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <main className="main-content">
      <div
        className="overlay"
        onClick={(e) => document.body.classList.toggle("sidebar-toggle")}
      ></div>
      <Box className="request-container-box">
        <div className="request-header">
          <Typography variant="h2">Submit Information</Typography>
          <Button onClick={handleOnBackButtonClick} variant="outlined">
            <img src={ArrowBack} alt="arrow" />
            Back
          </Button>
        </div>
        <Box>
          <Box className="request-box">
            <PatientDetails
              handleOnBackButtonClick={handleOnBackButtonClick}
              isRequestForMe={state?.usr?.isRequestForMe}
            />
          </Box>
        </Box>
      </Box>
    </main>
  );
};

export default CreateNewRequest;
